import React, { Component } from "react";
import { connect } from 'react-redux';
import { renderToString } from 'react-dom/server'

import { Button, Container, Row, Col } from 'react-bootstrap';
import { fetchBlogs, updateBlog } from '../actions/api'
// import { draftToMarkdown, markdownToDraft } from 'markdown-draft-js';
// import { convertToRaw, convertFromRaw, EditorState } from 'draft-js';
// import { useHistory } from 'react-router-dom';
import {
  faEdit,
  faUpload
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Table from './table';
class Blogs extends Component {
  constructor(props) {
    super(props);
    this.state = { blogs: null };
  }
  tableSchema = [
    {
      title: 'Id',
      // width: 120,
      data: 'id'
    },
    {
      title: 'Title',
      // width: 180,
      data: 'title'
    },
    {
      title: 'Published',
      // width: 180,
      data: 'published'
    },
    {
      title: 'Created at',
      // width: 180,
      data: 'created_at'
    },
    {
      title: 'Created by',
      // width: 180,
      data: 'created_by'
    },
    {
      title: 'Modified at',
      defaultContent: "N/A",
      data: 'modified_at'
    },
    {
      title: 'Modified by',
      defaultContent: "N/A",
      data: 'modified_by'
    },
    {
      title: "Actions",
      data: null,
      defaultContent: renderToString(
        <Container>
          <Row className="clearfix">
            <Col>
              <button title="Edit blog" className="btn btn-primary mr-1 editBlog" disabled={!(this.props.permissions.includes('MODIFY_BLOG') || this.props.permissions.includes('ADMIN'))}>
                <FontAwesomeIcon className="mr-1 ml-1" icon={faEdit} />
              </button>
            </Col>
            <Col>
              <button title="Publish blog" className="btn btn-success publishBlog" disabled={!(this.props.permissions.includes('MODIFY_BLOG') || this.props.permissions.includes('ADMIN'))}>
                <FontAwesomeIcon className="mr-1 ml-1" icon={faUpload} />
              </button>
            </Col>
          </Row>
        </Container >),
      ordering: false
    },
  ];
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.blogs !== this.state.blogs) {
      this.setState({ blogs: nextProps.blogs });
      return false
    }
    return true
  }
  handleEditBlog(payload) {
    // console.log(payload);
    // var a = markdownToDraft(payload.description);
    // var b = convertFromRaw(a);
    // var c = EditorState.createWithContent(b);
    const blogPayload = {
      blog_id: payload.id,
      content: payload.description,
      title: payload.title,
      featuredMediaPath: payload.featured_media,
      featuredMediaType: payload.featured_media_type || 'image/*',
      featuredImageUrl: payload.featured_image,
      category_id: payload.category_id,
      extraMedia: payload.medias,
      blogBodyRaw: payload.content_raw_draft,

    }
    // this.setState({
    //   ...blogPayload,
    //   renderInput: true,
    //   isEditing: true,
    //   prevBlogState: blogPayload
    // })
    this.props.history.push("/main/blogs/edit", { blogPayload, isEdit: true });
  }
  handleAddBlog() {
    this.props.history.push("/main/blogs/add", { isNew: true })
  }

  componentDidMount() {
    if (this.state.blogs === undefined || this.state.blogs === null)
      this.props.fetchBlogs();
  }

  handlePublishBlog(payload) {
    const blogPayload = {
      blog_id: payload.id,
      task: "PUBLISH"
    }
    this.props.updateBlog(blogPayload);
  }
  tableBTNTasks = [{
    className: 'editBlog',
    task: (event) => this.handleEditBlog(event)
  },
  {
    className: 'publishBlog',
    task: (event) => this.handlePublishBlog(event)
  }]

  render() {
    return (
      <div className="container-fluid">
        <div className="row align-items-center" >
          <div className="col-lg-12 col-md-12 col-sm-12">
            <>
              <div className="justify-content-end">
                <br></br>
                <Button onClick={() => this.handleAddBlog()} variant="primary" style={{
                  paddingLeft: "15px",
                  paddingRight: "15px",
                  fontWeight: "600"
                }} >

                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13" width="11px" height="11px" fill="#ffffff"><g data-name="Layer 2"><path d="M6.5.5v12m6-6H.5" fill="none" stroke="#ffffff" strokeLinecap="round"></path></g></svg>
                  Add new Blog
                </Button >
              </div>
              <Table data={this.state.blogs} schema={this.tableSchema} handleEditBlog={(a) => this.handleEditBlog(a)} buttonTasks={this.tableBTNTasks} />
            </>
          </div>
        </div>
      </div >
    );
  }
}
const mapStateToProps = ({ reducer: store }) => ({
  blogs: store.blogs,
  permissions: store.user.permissions
});

const mapDispatchToProps = {
  fetchBlogs: fetchBlogs,
  updateBlog
};

export default connect(mapStateToProps, mapDispatchToProps)(Blogs);